import type { IAppRegion } from '~/lib/appSettings';
import { useApi } from '~/lib/api';

export const useOptionalAppRegion = (): IAppRegion | undefined => {
  const api = useApi();
  const authorization = api.getAuthorization();

  return authorization?.region;
};
